export enum AppTheme {
  LIGHT = 'light',
  DARK = 'dark'
}

export interface UserPreferences {
  theme: AppTheme;
}